export default __webpack_public_path__ + "static/220803_天下布魔更新內容預告_en-ec1d9d7adbce7022f6511dd518fb13ee.png";